import { useState } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  TextField,
  Typography,
  Alert,
  Link,
} from '@mui/material'
import { authService } from '../services'
import { getApiErrorMessage } from '../services/apiClient'

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('')
  const [done, setDone] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const onSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      await authService.forgotPassword(email.trim())
      setDone(true)
    } catch (err) {
      // Still show generic success when possible; only show transport errors
      setError(getApiErrorMessage(err, ''))
      setDone(true)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        p: 2,
      }}
    >
      <Container maxWidth="sm">
        <Card sx={{ bgcolor: 'rgba(15,18,28,0.85)', color: '#fff' }}>
          <CardContent sx={{ p: 3 }}>
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
              Forgot password
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.8, mb: 2 }}>
              Enter your admin email. If an eligible password account exists, we will send a reset
              link.
            </Typography>
            {done ? (
              <Alert severity="info" sx={{ mb: 2 }}>
                If an eligible account exists, a password reset email has been sent. Check your
                inbox or spam folder.
              </Alert>
            ) : (
              <Box component="form" onSubmit={onSubmit}>
                {error ? (
                  <Alert severity="warning" sx={{ mb: 1 }}>
                    {error}
                  </Alert>
                ) : null}
                <TextField
                  fullWidth
                  required
                  type="email"
                  label="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  sx={{ mb: 2, input: { color: '#fff' }, label: { color: 'rgba(255,255,255,0.7)' } }}
                />
                <Button type="submit" fullWidth variant="contained" disabled={loading}>
                  Send reset link
                </Button>
              </Box>
            )}
            <Typography sx={{ mt: 2, textAlign: 'center' }}>
              <Link component={RouterLink} to="/login" sx={{ color: '#90caf9' }}>
                Back to sign in
              </Link>
            </Typography>
          </CardContent>
        </Card>
      </Container>
    </Box>
  )
}

export default ForgotPasswordPage
